module.exports = __webpack_public_path__ + "img/playstation.6b83c93b.svg";